
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {IIK121MaddeyeGoreYetkiVerilmesiTalep} from "@/interface/IUyapTalep";

@Component({
  components: {}
})
export default class Iik121MaddeyeGoreYetkiVerilmesiTalepEvrakForm extends Mixins(ObjectInputMixin) {
  localValue!: IIK121MaddeyeGoreYetkiVerilmesiTalep;
}
